<nz-table
    [@fadeAnimation]
    *ngIf="!intialProcessing"
    class="adspt-reusable adspt-table"
    [ngClass]="{ bordered: border, 'no-bordered': !border }"
    #adsptTable
    [nzBordered]="border"
    [nzWidthConfig]="columnsWidths"
    [nzLoading]="loading"
    nzSize="middle"
    [nzTitle]="title ? titleTmpl : null"
    [nzFooter]="footer ? footerTmpl : null"
    [nzData]="data"
    nzFrontPagination="false"
    [nzTotal]="total"
    [nzPageIndex]="pageIndex"
    [nzPageSize]="pageSize"
    [nzShowPagination]="total > 9"
    [nzShowSizeChanger]="total > 9"
    [nzPageSizeOptions]="[10, 25, 50, 100, 500]"
    [nzScroll]="hasInnerScroll ? scroll : null"
    [nzNoResult]="noResultTemplate || ('common.no-data' | translate)"
    [nzTableLayout]="tableLayout"
    (nzPageIndexChange)="onPageIndexChange($event)"
    (nzPageSizeChange)="onPageSizeChange($event)"
>
    <thead (nzSortOrderChange)="onSort($event)">
        <tr>
            <th *ngIf="expandable">
                <span style="visibility: hidden">*****</span>
            </th>
            <th
                *ngIf="selection"
                nzShowCheckbox
                [(nzChecked)]="isAllDisplayDataChecked"
                [nzIndeterminate]="isIndeterminate"
                (nzCheckedChange)="onAllChecked($event)"
            ></th>
            <th
                *ngFor="let column of config.columns"
                [nzAlign]="column.align || 'left'"
                nz-tooltip
                [nzTooltipTitle]="column.tooltip"
                nzTooltipPlacement="top"
                [nzShowSort]="column.sortable"
                [nzColumnKey]="column.key"
                [nzSortPriority]="!config.singleSort ? sortOrder[column.key] : false"
                [nzSortFn]="true"
                [nzSortOrder]="getColumnSort(column.key)"
                [nzShowFilter]="column.filterable"
                [nzFilters]="column.filterOptions | async"
                [adsptHeap]="heapFilterSelectors[column.key]"
                [heapDisabled]="!heapFilterSelectors[column.key]"
                (nzFilterChange)="onFilter($event, column.key)"
                [nzCustomFilter]="headerTemplates[column.key] || null"
            >
                <ng-container
                    *ngTemplateOutlet="headerTemplates[column.key] || defaultHeaderTmpl; context: { $implicit: column }"
                ></ng-container>

                <span class="sort-no" *ngIf="total > 1 && !config.singleSort && getColumnSort(column.key)">{{
                    sortOrder[column.key]
                }}</span>
            </th>
            <th *ngIf="hasActions" nzAlign="center">
                <ng-container
                    *ngTemplateOutlet="
                        headerTemplates.actions || defaultActionHeaderTmpl;
                        context: { $implicit: column }
                    "
                ></ng-container>
            </th>
        </tr>
    </thead>
    <tbody>
        <ng-container *ngFor="let data of adsptTable.data">
            <tr>
                <td
                    *ngIf="expandable"
                    nzShowExpand
                    [(nzExpand)]="data.expanded"
                    (nzExpandChange)="onExpandChanged(data)"
                    nzAlign="center"
                ></td>
                <td
                    *ngIf="selection"
                    nzShowCheckbox
                    [(nzChecked)]="data.checked"
                    (nzCheckedChange)="onRowChecked()"
                    nzAlign="center"
                ></td>
                <td *ngFor="let column of config.columns" [nzAlign]="column.align || 'left'">
                    <ng-container *ngIf="!columnTemplates[column.key]">
                        {{ data[column.key] }}
                    </ng-container>
                    <ng-container
                        *ngIf="columnTemplates[column.key]"
                        [ngTemplateOutlet]="columnTemplates[column.key]"
                        [ngTemplateOutletContext]="{ $implicit: data }"
                    >
                    </ng-container>
                </td>
                <td *ngIf="hasActions" align="center">
                    <ng-container
                        [ngTemplateOutlet]="actionsTemplate"
                        [ngTemplateOutletContext]="{ $implicit: data, items: adsptTable }"
                    >
                    </ng-container>
                </td>
            </tr>
            <tr [nzExpand]="data.expanded && expandable">
                <td></td>
                <td [attr.colspan]="expandRowColspan">
                    <ng-container [ngTemplateOutlet]="expandTemplate" [ngTemplateOutletContext]="{ $implicit: data }">
                    </ng-container>
                </td>
            </tr>
        </ng-container>
    </tbody>
</nz-table>
<div class="main-loader" *ngIf="intialProcessing">
    <nz-spin nzSimple></nz-spin>
</div>

<ng-template let-column #defaultHeaderTmpl>
    {{ column.displayName }}
</ng-template>

<ng-template let-column #defaultActionHeaderTmpl>
    {{ 'common.actions' | translate }}
</ng-template>

<ng-template #titleTmpl>
    <div class="title-wrapper">
        <ng-container *ngIf="config.title">
            <h2 *ngIf="(config.titleHeader || 'h2') === 'h2'">{{ config.title }}</h2>

            <h3 *ngIf="config.titleHeader || 'h3'">{{ config.title }}</h3>
        </ng-container>

        <div class="refiner search">
            <nz-input-group [nzPrefix]="prefixIconSearch" [nzSuffix]="suffixTemplate">
                <input
                    [adsptHeap]="heapSearchSelector"
                    type="text"
                    nz-input
                    [placeholder]="config.search?.placeholder || ('global-filter.search-placeholder' | translate)"
                    [formControl]="query"
                />
            </nz-input-group>
            <ng-template #prefixIconSearch>
                <adspt-icon name="zoom" class="search" />
            </ng-template>
            <ng-template #suffixTemplate>
                <adspt-icon name="close-circle" *ngIf="!!query.value" (click)="query.setValue('')" />
            </ng-template>
        </div>
    </div>
</ng-template>

<ng-template #footerTmpl>
    <p class="subtitle">
        <span *ngIf="total">{{ 'common.total' | translate }}: {{ total }}</span>
    </p>
</ng-template>
